import React from 'react';

export interface TechniqueInfo {
  name: string;
  count: number;
}

export interface TechniqueCardProps {
  technique?: TechniqueInfo | null;
  isEmpty?: boolean;
  emptyMessage?: string;
  className?: string;
}

const TechniqueCard: React.FC<TechniqueCardProps> = ({
  technique,
  isEmpty = false,
  emptyMessage = "Tag techniques on your trainings notes to discover which you apply more!",
  className = ""
}) => {
  if (isEmpty || !technique) {
    return (
      <div className={`flex flex-col items-center justify-center h-full w-full ${className}`}>
        {/* Zero Data State */}
        <div className="text-[24px] font-bold text-white mb-2">0</div>
        <p className="text-[10px] text-gray-400 text-center leading-tight px-1">
          {emptyMessage}
        </p>
      </div>
    );
  }

  return (
    <div className={`flex flex-col items-center justify-center h-full w-full ${className}`}>
      {/* Filled State - Technique Info */}
      <div className="text-[24px] font-bold text-white mb-2">{technique.count}</div>
      <div className="flex px-2 py-1 bg-sossiety-red rounded-full max-w-full">
        <span className="text-white text-[8px] font-medium truncate">{technique.name}</span>
      </div>
    </div>
  );
};

export default TechniqueCard;
